export const SpecialMarkingList = [
  'select', 'non veg', 'vegetarian', 'kosher', 'halal',
  'gluten free', 'ud', 'u', 'none'
]

export const servingTemperatureList = ['select', 'frozen', 'cold', 'warm', 'hot']

export const cuisineList = [
  'select', 'indian', 'mexican', 'american chinese', 'italian',
  'lebanese', 'turkish', 'fast food', 'chinese', 'mediterranean', 'mix of all'
]

export const SizeList = ['full', 'half']

export const ServingSizeList = [
  'one_person', 'two_person', 'three_person', 'four_person', 'family'
]

export const MealTypeList = ['All Day', 'Breakfast', 'Lunch', 'Dinner', 'Brunch']

export const RegularMenuCategory = [
  'select', 'appetizers', 'beverages', 'desserts', 'entrees', 'kids Menu',
  'salads', 'sandwiches', 'sides', 'drinks', 'soup', 'specials',
  'vegetarian Meals', 'burgers', 'chicken', 'fish', 'fries', 'wraps',
  'veggie Dishes', 'ramen', 'bakery', 'coffee', 'nachos', 'burritos',
  'tacos', 'bowls', 'main_course'
]

export const ComboMenuCategory = [
  'select', 'main dish', 'side', 'complementary', 'power side',
  'starter', 'drink or dessert or treat'
]

export const initialExtraToppingRow = {
  topping_name: '',
  topping_price: '',
  topping_available_quantity: '',
  errors: {}
}

export const statusTypeLabel = {
  admin_review_pending: 'Admin Review Pending',
  merchant_review_pending: 'Merchant Review Pending',
  ai_generated_merchant_review_pending: 'AI Merchant Review Pending',
  image_rejected_by_merchant: 'Image Rejected by Merchant',
  admin_rejected: 'Admin Rejected',
  merchant_approved: 'Merchant Approved',
  merchant_rejected: 'Merchant Rejected',
  approved: 'Approved',
  rejected: 'Rejected',
}

export const statusTypeColor = {
  admin_review_pending: '#ff7b29',
  merchant_review_pending: '#f0b429',
  ai_generated_merchant_review_pending: '#9c6bff',
  image_rejected_by_merchant: '#ff1d23',
  admin_rejected: '#ff1d23',
  merchant_approved: '#45bf55',
  merchant_rejected: '#ff1d23',
  approved: '#45bf55',
  rejected: '#ff1d23',
}

export const fieldLabelMap = {
  product_name: 'Product name',
  recipe_with: 'Recipe with',
  product_description: 'Product description',
  product_category: 'Product category',
  special_marking: 'Special marking',
  serving_temperature: 'Serving temperature',
  cuisine: 'Cuisine',
  size: 'Size',
  serving_size: 'Serving size',
  meal_type: 'Meal type',
  price: 'Price',
  available_quantity: 'Available quantity',
  serving_days: 'Serving days',
  extra_toppings: 'Extra toppings',
  product_promotion: 'Promotions',
  ingredients: 'Ingredients',
  allergic_ingredients: 'Allergic ingredients',
  image_url: 'Product image',
  ingredients_image: 'Ingredients image'
}
